import { cn } from "@/lib/utils"

interface ProgressProps extends React.ComponentProps<"div"> {
  /** 0-100. If undefined, renders as indeterminate (animated pulse). */
  value?: number
}

function Progress({ value, className, ...props }: ProgressProps) {
  const indeterminate = value === undefined || value === null

  return (
    <div
      data-slot="progress"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={indeterminate ? undefined : value}
      className={cn("relative h-2 w-full overflow-hidden rounded-full bg-muted", className)}
      {...props}
    >
      {indeterminate ? (
        <div className="absolute inset-y-0 left-0 w-1/2 rounded-full bg-primary animate-progress-indeterminate" />
      ) : (
        <div
          className="h-full rounded-full bg-primary transition-all duration-300"
          style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
        />
      )}
    </div>
  )
}

export { Progress }
